import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { applySolarSungageApplicationState } from "./solar-sungage-application-cache"
import type { SolarSungageApplicationHandoffDto } from "../dto/solar-sungage.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** Resume the same Sungage attempt's hosted application. Never creates a replacement. */
export default function useResumeSolarSungageApplication(): UseMutationResult<
  SolarSungageApplicationHandoffDto,
  unknown,
  { proposalId: string; applicationId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, applicationId }) =>
      solarProposalService.resumeSungageApplication(proposalId, applicationId),
    onSuccess: (handoff, { proposalId }) =>
      applySolarSungageApplicationState(queryClient, proposalId, handoff),
  })
}
